import { render, staticRenderFns } from "./SelectIcon.vue?vue&type=template&id=65db5828&scoped=true&"
import script from "./SelectIcon.vue?vue&type=script&lang=js&"
export * from "./SelectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db5828",
  null
  
)

export default component.exports